export default theme => ({
  root: {},
  form: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  group: {
    flexGrow: 1,
    padding: theme.spacing(2)
  },
  groupLabel: {
    paddingLeft: theme.spacing(2)
  },
  field: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  field2: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    width: '20px',
    //maxWidth: '100%',
    marginRight: theme.spacing(3)
  },
  portletFooter: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  formControl: {
    //margin: theme.spacing.unit * 2,
    minWidth: 120,
    width: '100%',
  },
  textFieldSelect: {
    width: '60%',
    marginBottom: theme.spacing(2)
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
  },
  snackContent: {
    backgroundColor: theme.palette.error.dark,
  },
  snackContentOk: {
    backgroundColor: theme.palette.success.main,
  },
  profileDivider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    //Cambia estilo base, por custom
    backgroundColor: '#333333',
    
},
});
